var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirepitWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Firepit_White",
    "data-name": "Firepit White",
    xmlns: "http://www.w3.org/2000/svg",
    width: 156.5,
    height: 230.767,
    viewBox: "0 0 156.5 230.767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff8f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    className: "cls-1",
    d: "M153.478,137.34v-.32L145.772,117.8a3.839,3.839,0,0,0-6.559-.987l-8,9.945a6.768,6.768,0,1,1-10.478-8.559,34.075,34.075,0,0,0,.293-44.074L118.2,70.709a3.839,3.839,0,0,0-6.692,1.546l-1.04,4.186a10.932,10.932,0,0,1-6.772,7.572V78.068A55.139,55.139,0,0,0,93.326,45.833a47.514,47.514,0,0,1-8.905-27.756V3.839A3.893,3.893,0,0,0,82.394.453a3.919,3.919,0,0,0-3.973.187L62,11.6A29.7,29.7,0,0,0,51.332,48.446a21.917,21.917,0,0,1-3.146,23.01L17.017,109.131a74.31,74.31,0,0,0,57.3,121.636h7.839A73.829,73.829,0,0,0,134.68,209.01l.987-.987a70.95,70.95,0,0,0,17.811-70.683Zm-23.25,65.3-.987.96a66.1,66.1,0,0,1-47.087,19.517H74.316A66.657,66.657,0,0,1,22.963,114.037l31.116-37.7a29.569,29.569,0,0,0,4.266-31.009,22,22,0,0,1,8-27.329L76.8,11.038v7.039A55.272,55.272,0,0,0,87.14,50.312a47.513,47.513,0,0,1,8.852,27.756v10.4a3.866,3.866,0,0,0,3.866,3.839A18.664,18.664,0,0,0,116.87,81.268a26.4,26.4,0,0,1-1.973,31.809,14.549,14.549,0,1,0,22.317,18.664l3.839-4.8,5.173,12.932a63.325,63.325,0,0,1-16,62.871Z",
    transform: "translate(0.004 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    className: "cls-1",
    d: "M101.687,102.048a3.839,3.839,0,0,0-3.679,1.013l-11.172,11.2A7.546,7.546,0,0,1,75.691,104.1a33.889,33.889,0,0,0,4.266-36.848L61.826,30.991a3.828,3.828,0,0,0-7.252,1.36L51.695,63.04A23.73,23.73,0,0,1,42.949,79.3L27.111,92A39.435,39.435,0,0,0,12.18,123.031V127.4a39.781,39.781,0,0,0,39.861,39.781H63.56A39.568,39.568,0,0,0,91.4,155.427h0a51.7,51.7,0,0,0,13.011-50.66,3.839,3.839,0,0,0-2.666-2.666Zm-15.7,47.807h0a31.836,31.836,0,0,1-22.45,9.465H52.414a32,32,0,0,1-32.4-32v-4.293A32,32,0,0,1,32.071,97.995L47.855,85.25A31.462,31.462,0,0,0,59.48,63.68l1.546-17.224,12,24.237a26.263,26.263,0,0,1-3.333,28.5,15.225,15.225,0,0,0,22.477,20.477l6.132-6.132a44.074,44.074,0,0,1-12.425,36.315Z",
    transform: "translate(20.305 48.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    className: "cls-1",
    d: "M4.258,30.027v7.679a3.866,3.866,0,0,0,7.706,0V30.027a3.866,3.866,0,1,0-7.706,0Z",
    transform: "translate(7.083 43.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    className: "cls-1",
    d: "M12.4,34.135A3.813,3.813,0,0,0,16.239,30.3V22.589a3.839,3.839,0,1,0-7.679,0V30.3A3.813,3.813,0,0,0,12.4,34.135Z",
    transform: "translate(14.273 31.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    className: "cls-1",
    d: "M6.65,28.365a3.813,3.813,0,0,0,3.839-3.839V16.819a3.839,3.839,0,1,0-7.679,0v7.706A3.813,3.813,0,0,0,6.65,28.365Z",
    transform: "translate(4.692 21.628)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    className: "cls-1",
    d: "M57.156,45.491A3.839,3.839,0,0,0,61,41.651V33.946a3.866,3.866,0,0,0-7.706,0v7.706a3.839,3.839,0,0,0,3.866,3.839Z",
    transform: "translate(88.806 50.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    className: "cls-1",
    d: "M52.811,35.664a3.813,3.813,0,0,0,3.839-3.839V24.039a3.839,3.839,0,1,0-7.679,0v7.679a3.813,3.813,0,0,0,3.839,3.946Z",
    transform: "translate(81.607 33.658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-1",
    d: "M58.58,33.654a3.839,3.839,0,0,0,3.839-3.866V18.269a3.839,3.839,0,1,0-7.679,0V29.788a3.839,3.839,0,0,0,3.839,3.866Z",
    transform: "translate(91.222 24.044)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirepitWhite);
export default __webpack_public_path__ + "static/media/Firepit_White.83d6d801217935c670fdcdb4ddf6a5d5.svg";
export { ForwardRef as ReactComponent };